<template>
  <breeze-authenticated-layout>
    <div class="row">
      <div class="col-12"></div>
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
export default {
  components: {
    BreezeAuthenticatedLayout,
  },
}
</script>
